import React from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import BadgeUI from '../../../widgets/output/BadgeUI'
import ButtonUI from '../../../widgets/action/ButtonUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LabelAndValueUI from '../../../widgets/layout/LabelAndValueUI'
// import './TransactionList2.css'

// ***********************************************************
// reused from superadmin console and end user console for now
// ***********************************************************

const TransactionListUI = ({ context, txnList,
  onCopyToClipboard, copyToClipboardText,
  hasMore, onMoreTransactions, gettingMore,
  bankAccountNumber
}) =>
  <div className='txns'>
    <LRTableBodyUI className='data_tbl'>
      {
        txnList.map((txn, i) =>
          <TxnRowUI key={i} context={context} txn={txn}
            onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
          />
        )
      }
    </LRTableBodyUI>

    <LRTableActionsUI location='bottom'
      left={<span />}
      right={
        <div>
          {
            hasMore &&
            <div className='action g_flex_h'>
              <SpinnerUI show={gettingMore} />
              <span className='g_m_left_50' />
              <ButtonUI label='More' onClick={onMoreTransactions} />
            </div>
          }
          {
            !hasMore &&
            <div>All transactions displayed</div>
          }
        </div>
      }
    />

  </div>

const TxnRowUI = ({ context, txn, onCopyToClipboard, copyToClipboardText}) =>
  <LRTableRowUI
    context={context}
    left={<RowLeftUI context={context} txn={txn}
      onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
    />}
    right={<RowRightUI context={context} txn={txn} />}
    className='g_flex_top'
  />

const RowLeftUI = ({ context, txn, onCopyToClipboard, copyToClipboardText}) =>
  <div className='g_flex_v'>
    <span className=''>
      {txn.transactionDateF}
      <span className='g_muted g_m_left_50'>{txn.transactionId}</span>
      <span onClick={e => e.stopPropagation()}>
        <CopyToClipboard text={txn.transactionId}
          onCopy={onCopyToClipboard}>
          <span className='g_m_left_50 g_muted icon icon-clone g_cursor_pointer' />
        </CopyToClipboard>
        {
          copyToClipboardText === txn.transactionId &&
          <span className='g_m_left_50 g_muted'>copied</span>
        }
      </span>
    </span>

    <span className='g_small'>{txn.particulars}</span>
    {
      txn.bankReferenceNum && !txn.particulars &&
      <span className='g_small'>
        UTR: {txn.bankReferenceNum}
      </span>
    }

    {
      txn.type &&
      <span className='g_m_top_25'>
        <BadgeUI label={txn.type} />
        {
          txn.remitter &&
          <span className='g_m_left_50 icon icon-angle-left'> {txn.remitter}</span>
        }
        {
          txn.payee &&
          <span className='g_m_left_50 icon icon-angle-right'> {txn.payee}</span>
        }
      </span>
    }
  </div>

const RowRightUI = ({ context, txn }) =>
  <div className='g_flex_v g_text_right'>
    {
      txn.status === 'pending' &&
      <div>
        <BadgeUI label={txn.status} />
      </div>
    }
    <span>{txn.amount < 0 ? `(${txn.amountF1})` : `${txn.amountF1}`}</span>
    {
      txn.tdsAmountF2 &&
      <span className='g_muted'>TDS {txn.tdsSection} @{txn.tdsRate}% {txn.tdsAmountF2}</span>
    }
  </div>

export default TransactionListUI
